import React from 'react'

import MatchView from 'tennders-transactions/views/assign-match/MatchView'
import useTransactionDetailStore from 'tennders-transactions/stores/useTransactionDetailStore'
import AssignLoads from './AssignLoads'
import AssignTrucks from './AssignTrucks'

const AssignView = () => {
  const [assignTruckLoadType] = useTransactionDetailStore(state => [state.assignTruckLoadType])

  return (
    <>
      {assignTruckLoadType === 'load' && <AssignLoads /> }
      {assignTruckLoadType === 'truck' && <AssignTrucks />}
      <MatchView
        loadToMatch={assignTruckLoadType?.includes('load')}
        truckToMatch={assignTruckLoadType?.includes('truck')}
      />
    </>
  )
}

export default React.memo(AssignView)
